import { Breakpoint } from '@mui/material';

import type { Theme } from '../../themes/themes';

const makeArea = (columnStart: number, rowStart: number, columnEnd: number, rowEnd: number) => {
  return {
    gridColumn: columnStart,
    gridRow: rowStart,
    gridColumnEnd: columnEnd,
    gridRowEnd: rowEnd,
  };
};

const mediaRightOnMobile = (theme: Theme) => {
  return {
    '& .MuiCardMedia-root': {
      minWidth: '100%',

      ...makeArea(2, 1, 3, 3),
      [theme.breakpoints.up('lg')]: {
        ...makeArea(1, 1, 2, 2),
      },
    },
    '& .MuiCardHeader-headline': {
      ...makeArea(1, 1, 2, 2),
      [theme.breakpoints.up('lg')]: {
        ...makeArea(1, 2, 2, 3),
      },
    },
    '& .MuiCardContent-root': {
      ...makeArea(1, 2, 2, 3),
      [theme.breakpoints.up('lg')]: {
        ...makeArea(1, 3, 2, 4),
      },
    },
    '& .MuiCardHeader-tag': {
      ...makeArea(1, 3, 3, 4),
      [theme.breakpoints.up('lg')]: {
        ...makeArea(1, 4, 2, 5),
      },
    },
    '& .MuiCardActions-root': {
      ...makeArea(1, 4, 3, 5),
      [theme.breakpoints.up('lg')]: {
        ...makeArea(1, 5, 2, 6),
      },
    },
  };
};

const mediaRightOnDesktop = (theme: Theme, breakPoint: Breakpoint = 'lg') => {
  return {
    '& .MuiCardMedia-root': {
      minWidth: '100%',

      gridColumn: 1,
      gridRow: 1,
      [theme.breakpoints.up(breakPoint)]: {
        ...makeArea(2, 1, 3, 4),
      },
    },
    '& .MuiCardHeader-headline': {
      gridColumn: 1,
      gridRow: 2,
      [theme.breakpoints.up(breakPoint)]: {
        ...makeArea(1, 1, 2, 2),
      },
    },
    '& .MuiCardContent-root': {
      gridColumn: 1,
      gridRow: 3,
      [theme.breakpoints.up(breakPoint)]: {
        ...makeArea(1, 2, 2, 3),
      },
    },
    '& .MuiCardHeader-tag': {
      gridColumn: 1,
      gridRow: 4,
      [theme.breakpoints.up(breakPoint)]: {
        ...makeArea(1, 3, 2, 4),
      },
    },
    '& .MuiCardActions-root': {
      gridColumn: 1,
      gridRow: 5,
      [theme.breakpoints.up(breakPoint)]: {
        ...makeArea(1, 4, 3, 5),
      },
    },
  };
};

const mediaLeft = (theme: Theme, breakPoint: Breakpoint = 'lg') => {
  return {
    '& .MuiCardMedia-root': {
      minWidth: '100%',

      gridColumn: 1,
      gridRow: 1,
      [theme.breakpoints.up(breakPoint)]: {
        ...makeArea(1, 1, 2, 4),
      },
    },
    '& .MuiCardHeader-headline': {
      gridColumn: 1,
      gridRow: 2,
      [theme.breakpoints.up(breakPoint)]: {
        ...makeArea(2, 1, 3, 2),
      },
    },
    '& .MuiCardContent-root': {
      gridColumn: 1,
      gridRow: 3,
      [theme.breakpoints.up(breakPoint)]: {
        ...makeArea(2, 2, 3, 3),
      },
    },
    '& .MuiCardHeader-tag': {
      gridColumn: 1,
      gridRow: 4,
      [theme.breakpoints.up(breakPoint)]: {
        ...makeArea(2, 3, 3, 4),
      },
    },
    '& .MuiCardActions-root': {
      gridColumn: 1,
      gridRow: 5,
      [theme.breakpoints.up(breakPoint)]: {
        ...makeArea(1, 4, 3, 5),
      },
    },
  };
};

const verticalCenterContentLeft = (theme: Theme) => {
  return {
    '& .MuiCardMedia-root': {
      minWidth: '100%',
      gridColumn: 1,
      gridRow: 1,
      [theme.breakpoints.up('sm')]: {
        ...makeArea(1, 1, 2, 7),
      },
    },
    '& .MuiCardHeader-headline': {
      gridColumn: 1,
      gridRow: 2,
      [theme.breakpoints.up('sm')]: {
        ...makeArea(2, 2, 3, 3),
      },
    },
    '& .MuiCardContent-root': {
      gridColumn: 1,
      gridRow: 3,
      [theme.breakpoints.up('sm')]: {
        ...makeArea(2, 3, 3, 4),
      },
    },
    '& .MuiCardHeader-tag': {
      gridColumn: 1,
      gridRow: 4,
      [theme.breakpoints.up('sm')]: {
        ...makeArea(2, 4, 3, 5),
      },
    },
    '& .MuiCardActions-root': {
      gridColumn: 1,
      gridRow: 5,
      [theme.breakpoints.up('sm')]: {
        ...makeArea(1, 6, 3, 7),
      },
    },
  };
};

const verticalCenterContentRight = (theme: Theme) => {
  return {
    '& .MuiCardMedia-root': {
      minWidth: '100%',
      gridColumn: 1,
      gridRow: 1,
      [theme.breakpoints.up('sm')]: {
        ...makeArea(2, 1, 3, 6),
      },
    },
    '& .MuiCardHeader-headline': {
      gridColumn: 1,
      gridRow: 2,
      [theme.breakpoints.up('sm')]: {
        ...makeArea(1, 2, 2, 3),
      },
    },
    '& .MuiCardContent-root': {
      gridColumn: 1,
      gridRow: 3,
      [theme.breakpoints.up('sm')]: {
        ...makeArea(1, 3, 2, 4),
      },
    },
    '& .MuiCardHeader-tag': {
      gridColumn: 1,
      gridRow: 4,
      [theme.breakpoints.up('sm')]: {
        ...makeArea(1, 4, 2, 5),
      },
    },
    '& .MuiCardActions-root': {
      gridColumn: 1,
      gridRow: 5,
      [theme.breakpoints.up('lg')]: {
        ...makeArea(1, 6, 3, 7),
      },
    },
  };
};

const product = (theme: Theme) => {
  return {
    '& .MuiCardContent-root': {
      '& >.MuiTypography-root:not(:last-child)': {
        marginBottom: theme.spacing(3),

        [theme.breakpoints.up('lg')]: {
          marginBottom: theme.spacing(5),
        },
      },
      '& ul': {
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up('lg')]: {
          marginBottom: theme.spacing(5),
        },
      },
      '& a': {
        borderColor: theme.palette.grey['300'],
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        '&:last-of-type': {
          border: 'none',
        },
      },
    },
    '& .MuiCardHeader-headline': {
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(8),

      [theme.breakpoints.up('lg')]: {
        marginBottom: theme.spacing(8),
        marginTop: 0,
      },
    },
    '& .MuiCardHeader-title': {
      display: 'flex',
      boxSizing: 'border-box',
      flexWrap: 'wrap',
      rowGap: theme.spacing(3),
    },
  };
};

export const createCardTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          height: '100%',
          alignContent: 'start',
          gridRowGap: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            gridRowGap: theme.spacing(6),
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: {
                variant: 'content:heroThirdRight',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('sm')]: {
                  gridTemplateColumns: '1fr 2fr',
                  gridTemplateRows: '1fr repeat(3, min-content) 1fr min-content',
                },
                ...verticalCenterContentRight(theme),
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'content:heroThirdLeft',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('sm')]: {
                  gridTemplateColumns: '2fr 1fr',
                  gridTemplateRows: '1fr repeat(3, min-content) 1fr min-content',
                },
                ...verticalCenterContentLeft(theme),
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'content:small',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(5),
                gridTemplateColumns: '4fr 8fr',
                [theme.breakpoints.up('sm')]: {
                  gridColumnGap: theme.spacing(6),
                  gridTemplateColumns: '8fr 4fr',
                },
                [theme.breakpoints.up('lg')]: {
                  gridColumnGap: theme.spacing(6),
                  gridTemplateColumns: '5fr 2fr',
                },
                '& .MuiCardMedia-root': {
                  ...makeArea(1, 1, 2, 2),
                  [theme.breakpoints.up('sm')]: {
                    ...makeArea(2, 1, 3, 2),
                  },
                },
                '& .MuiCardHeader-headline': {
                  ...makeArea(2, 1, 3, 2),
                  [theme.breakpoints.up('sm')]: {
                    ...makeArea(1, 1, 2, 2),
                  },
                },
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
                '& .MuiCardContent-root': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'content:jobStandard',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(5),
                gridTemplateColumns: '4fr 8fr',
                [theme.breakpoints.up('sm')]: {
                  gridColumnGap: theme.spacing(6),
                  gridTemplateColumns: '8fr 4fr',
                },
                [theme.breakpoints.up('lg')]: {
                  gridColumnGap: theme.spacing(6),
                  gridTemplateColumns: '5fr 2fr',
                },
                '& .MuiCardHeader-headline': {
                  ...makeArea(1, 1, 3, 2),
                  [theme.breakpoints.up('sm')]: {
                    ...makeArea(1, 1, 3, 2),
                  },
                },
              },
            },
            {
              props: {
                variant: 'content:jobPremium',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(1),
                gridTemplateColumns: '1fr 4fr',

                [theme.breakpoints.up('lg')]: {
                  gridColumnGap: theme.spacing(4),
                  gridTemplateColumns: '1fr 4fr',
                },
                '& .MuiCardMedia-root': {
                  marginLeft: theme.spacing(4),
                  ...makeArea(1, 1, 2, 2),
                  [theme.breakpoints.up('sm')]: {
                    ...makeArea(1, 1, 2, 2),
                    padding: theme.spacing(2),
                  },
                  [theme.breakpoints.up('lg')]: {
                    marginLeft: theme.spacing(8),
                  },
                },
                '& .MuiCardHeader-headline': {
                  ...makeArea(2, 1, 3, 2),
                  [theme.breakpoints.up('sm')]: {
                    ...makeArea(2, 1, 3, 2),
                  },
                },
              },
            },
            {
              props: {
                variant: 'content:heroHalfLeft',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('sm')]: {
                  gridRowGap: 0,
                  gridTemplateColumns: '1fr 1fr',
                  gridTemplateRows: '1fr repeat(3, min-content) 1fr min-content',
                },
                ...verticalCenterContentLeft(theme),
              },
            },
            {
              props: {
                variant: 'content:heroHalfRight',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('sm')]: {
                  gridTemplateColumns: '1fr 1fr',
                  gridTemplateRows: '1fr repeat(3, min-content) 1fr min-content',
                },
                ...verticalCenterContentRight(theme),
              },
            },
            {
              props: {
                variant: 'content:oneHalf',
              },
              style: {
                display: 'grid',
                gridTemplateColumns: '12fr',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('lg')]: {
                  gridColumnGap: theme.spacing(0),
                },
                '& .MuiCardMedia-root': {
                  minWidth: '100%',
                },
                '& .MuiCardContent-root': {
                  alignSelf: 'center',
                },
                '& .MuiCardHeader-headline': {},
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'content:oneThird',
              },
              style: {
                display: 'grid',
                '& .MuiCardMedia-root': {
                  minWidth: '100%',
                },
                '& .MuiCardContent-root': {},
                '& .MuiCardHeader-headline': {},
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'seminar',
              },
              style: {
                display: 'grid',
                gridTemplateColumns: '2fr 1fr',

                gridColumnGap: theme.spacing(4),

                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '1fr',
                },
                ...mediaRightOnMobile(theme),
              },
            },
            {
              props: {
                variant: 'campaign',
              },
              style: {
                display: 'grid',

                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '1fr 2fr',
                  gridColumnGap: theme.spacing(11),
                },
                '& .MuiCardMedia-root': {
                  gridRowStart: 2,
                  gridRowEnd: 3,
                  gridColumn: 1,

                  justifySelf: 'end',
                  minWidth: '100%',

                  [theme.breakpoints.up('lg')]: {
                    gridColumn: 2,
                    gridRowStart: 1,
                    gridRowEnd: 3,
                  },
                },
                '& .MuiCardContent-root': {
                  alignSelf: 'end',

                  [theme.breakpoints.up('lg')]: {
                    gridRow: 2,
                    paddingBottom: theme.spacing(9),
                  },
                },
                '& .MuiCardHeader-headline': {
                  alignItems: 'start',
                  [theme.breakpoints.up('lg')]: {
                    paddingTop: theme.spacing(6),
                  },
                },
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'content:recommendation',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(4),
                gridTemplateColumns: '4fr 8fr',
                paddingLeft: theme.spacing(5),
                paddingRight: theme.spacing(5),

                [theme.breakpoints.up('sm')]: {
                  gridTemplateColumns: '6fr 2fr ',
                  gridColumnGap: theme.spacing(8),
                  paddingLeft: theme.spacing(6),
                  paddingRight: theme.spacing(9),
                },
                [theme.breakpoints.up('md')]: {
                  gridTemplateColumns: '6fr 1fr ',
                  gridColumnGap: theme.spacing(8),
                  paddingLeft: theme.spacing(6),
                  paddingRight: theme.spacing(9),
                },
                '& .MuiCardMedia-root': {
                  gridRowStart: 1,
                  gridRowEnd: 3,
                  gridColumn: 1,

                  alignSelf: 'start',
                  minWidth: '100%',

                  [theme.breakpoints.up('sm')]: {
                    gridRowStart: 1,
                    gridRowEnd: 4,
                    gridColumn: 2,
                    alignSelf: 'center',
                  },
                  [theme.breakpoints.up('md')]: {
                    gridRowStart: 1,
                    gridRowEnd: 4,
                    gridColumn: 2,
                    alignSelf: 'center',
                  },
                },
                '& .MuiCardContent-root': {
                  gridRow: 2,
                  gridColumn: 2,

                  alignSelf: 'start',

                  [theme.breakpoints.up('sm')]: {
                    gridRowStart: 2,
                    gridRowEnd: 2,
                    gridColumn: 1,
                  },
                },
                '& .MuiCardHeader-headline': {
                  gridRowStart: 1,
                  gridColumn: 2,

                  alignItems: 'start',

                  [theme.breakpoints.up('sm')]: {
                    gridRowStart: 1,
                    gridRowEnd: 1,
                    gridColumn: 1,
                  },
                },
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'info',
              },
              style: {
                backgroundColor: theme.palette.grey['300'],
                padding: theme.spacing(8),

                '& .MuiCardMedia-root': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'wall',
              },
              style: {
                '& .MuiCardMedia-root': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'horizontalLarge',
              },
              style: {
                display: 'grid',

                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '1fr 1fr',
                  gridColumnGap: theme.spacing(8),
                },
                '& .MuiCardMedia-root': {
                  minWidth: '100%',
                  [theme.breakpoints.up('lg')]: {
                    gridRowStart: 1,
                    gridRowEnd: 3,
                    gridColumn: 2,
                  },
                },
                '& .MuiCardContent-root': {
                  [theme.breakpoints.up('lg')]: {
                    display: 'grid',
                    alignItems: 'end',
                  },
                },
                '& .MuiCardHeader-headline': {
                  alignItems: 'start',
                  [theme.breakpoints.up('lg')]: {
                    paddingTop: theme.spacing(6),
                  },
                },
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'content:list',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(5),
                gridTemplateColumns: '4fr 8fr',

                [theme.breakpoints.up('sm')]: {
                  gridTemplateColumns: '4fr 6fr 2fr',
                  gridColumnGap: theme.spacing(8),
                },
                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '3fr 7fr 2fr',
                  gridColumnGap: theme.spacing(8),
                },
                '& .MuiCardMedia-root': {
                  gridRowStart: 2,
                  gridRowEnd: 4,
                  gridColumn: 1,

                  alignSelf: 'center',
                  width: '100%',

                  [theme.breakpoints.up('sm')]: {
                    gridRowStart: 1,
                    gridRowEnd: 3,
                    gridColumn: 3,
                  },
                },
                '& .MuiCardContent-root': {
                  gridRow: 3,
                  gridColumn: 2,

                  alignSelf: 'start',

                  [theme.breakpoints.up('sm')]: {
                    gridRow: 2,
                    gridColumn: 2,
                  },
                },
                '& .MuiCardHeader-headline': {
                  gridRow: 2,
                  gridColumn: 2,

                  alignSelf: 'start',

                  [theme.breakpoints.up('sm')]: {
                    gridRowStart: 1,
                    gridRowEnd: 2,
                  },
                },
                '& .MuiCardHeader-tag': {
                  gridRowStart: 1,
                  gridRowEnd: 2,
                  gridColumnStart: 1,
                  gridColumnEnd: 3,

                  alignItems: 'start',

                  marginLeft: theme.spacing(5),

                  [theme.breakpoints.up('sm')]: {
                    gridRowStart: 1,
                    gridRowEnd: 3,
                    gridColumnStart: 1,
                    gridColumnEnd: 1,
                  },
                  [theme.breakpoints.up('lg')]: {
                    marginLeft: theme.spacing(6),
                  },
                },
              },
            },
            {
              props: {
                variant: 'productExtraLargeMediaRight',
              },
              style: {
                display: 'grid',
                flexFlow: 'column',
                cursor: 'default',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '1fr 2fr',
                },
                ...mediaRightOnDesktop(theme),
                ...product(theme),
              },
            },
            {
              props: {
                variant: 'productLargeMediaRight',
              },
              style: {
                display: 'grid',
                flexFlow: 'column',
                cursor: 'default',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '1fr 1fr',
                },
                ...mediaRightOnDesktop(theme),
                ...product(theme),
              },
            },
            {
              props: {
                variant: 'productExtraLargeMediaLeft',
              },
              style: {
                display: 'grid',
                flexFlow: 'column',
                cursor: 'default',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '2fr 1fr',
                },
                ...mediaLeft(theme),
                ...product(theme),
              },
            },
            {
              props: {
                variant: 'productLargeMediaLeft',
              },
              style: {
                display: 'grid',
                flexFlow: 'column',
                cursor: 'default',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '1fr 1fr',
                },
                ...mediaLeft(theme),
                ...product(theme),
              },
            },
            {
              props: {
                variant: 'productMedium',
              },
              style: {
                display: 'grid',
                flexFlow: 'column',
                cursor: 'default',
                gridColumnGap: theme.spacing(9),
                ...product(theme),
              },
            },
            {
              props: {
                variant: 'product:heroThirdLeft',
              },
              style: {
                display: 'grid',
                gridTemplateRows: 'min-content',
                gridColumnGap: theme.spacing(9),
                gridRowGap: theme.spacing(5),
                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '2fr 1fr',
                },
                ...mediaLeft(theme, 'sm'),
                '& .MuiCardHeader-headline': {
                  gridColumn: 1,
                  gridRow: 2,
                  marginTop: theme.spacing(5),

                  [theme.breakpoints.up('sm')]: {
                    ...makeArea(2, 1, 3, 2),
                  },

                  [theme.breakpoints.up('lg')]: {
                    marginTop: theme.spacing(6),
                  },
                },
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'product:heroThirdRight',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(9),
                gridRowGap: theme.spacing(5),
                [theme.breakpoints.up('sm')]: {
                  gridTemplateColumns: '1fr 2fr',
                },
                ...mediaRightOnDesktop(theme, 'sm'),
                '& .MuiCardHeader-headline': {
                  gridColumn: 1,
                  gridRow: 2,
                  marginTop: theme.spacing(5),
                  [theme.breakpoints.up('sm')]: {
                    ...makeArea(1, 1, 2, 2),
                  },
                  [theme.breakpoints.up('lg')]: {
                    marginTop: theme.spacing(6),
                  },
                },
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'product:half',
              },
              style: {
                display: 'grid',
                gridTemplateColumns: '1fr',
                gridColumnGap: theme.spacing(9),
                gridRowGap: theme.spacing(5),
                '& .MuiCardHeader-root': {
                  marginTop: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    marginTop: theme.spacing(6),
                  },
                },
              },
            },
            {
              props: {
                variant: 'product:halfSquare',
              },
              style: {
                display: 'grid',
                gridTemplateColumns: '1fr',
                gridColumnGap: theme.spacing(9),
                gridRowGap: theme.spacing(5),
                '& .MuiCardHeader-root': {
                  marginTop: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    marginTop: theme.spacing(6),
                  },
                },
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'product:third',
              },
              style: {
                display: 'grid',
                gridTemplateColumns: '1fr',
                gridColumnGap: theme.spacing(9),
                gridRowGap: theme.spacing(5),
                '& .MuiCardHeader-root': {
                  marginTop: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    marginTop: theme.spacing(6),
                  },
                },
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'product:thirdSquare',
              },
              style: {
                display: 'grid',
                gridTemplateColumns: '1fr',
                gridColumnGap: theme.spacing(9),
                gridRowGap: theme.spacing(5),
                '& .MuiCardHeader-root': {
                  marginTop: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    marginTop: theme.spacing(6),
                  },
                },
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'product:fourth',
              },
              style: {
                display: 'grid',
                gridTemplateColumns: '1fr',
                gridColumnGap: theme.spacing(9),
                gridRowGap: theme.spacing(5),
                '& .MuiCardHeader-root': {
                  marginTop: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    marginTop: theme.spacing(6),
                  },
                },
                '& .MuiCardHeader-tag': {
                  display: 'none',
                },
              },
            },
            {
              props: {
                variant: 'service:heroMediaLeft',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '2fr 1fr',
                  gridTemplateRows: 'min-content min-content 1fr',
                },

                '& .MuiCardHeader-root': {
                  marginLeft: theme.spacing(5),
                  marginRight: theme.spacing(5),
                  marginTop: theme.spacing(5),

                  [theme.breakpoints.up('lg')]: {
                    marginLeft: theme.spacing(0),
                    marginRight: theme.spacing(0),
                    marginTop: theme.spacing(6),
                    alignItems: 'start',
                  },
                },

                '& .MuiCardMedia-root': {
                  minWidth: '100%',
                  [theme.breakpoints.up('lg')]: {
                    ...makeArea(1, 1, 2, 4),
                  },
                },
                '& .MuiCardContent-root': {
                  '&:empty': {
                    display: 'none',
                  },

                  marginLeft: theme.spacing(5),
                  marginRight: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    marginLeft: theme.spacing(0),
                    marginRight: theme.spacing(0),
                  },
                },
                '& .MuiCardActions-root': {
                  display: 'block',

                  marginLeft: theme.spacing(8),
                  marginRight: theme.spacing(8),
                  marginTop: theme.spacing(5),
                  marginBottom: theme.spacing(5),

                  [theme.breakpoints.up('lg')]: {
                    margin: theme.spacing(6),
                    alignSelf: 'start',
                  },
                },
              },
            },
            {
              props: {
                variant: 'service:heroMediaRight',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '1fr 2fr',
                  gridTemplateRows: 'min-content min-content 1fr',
                },

                '& .MuiCardHeader-root': {
                  marginLeft: theme.spacing(5),
                  marginRight: theme.spacing(5),
                  marginTop: theme.spacing(5),

                  [theme.breakpoints.up('lg')]: {
                    marginLeft: theme.spacing(0),
                    marginRight: theme.spacing(0),
                    marginTop: theme.spacing(6),
                    alignItems: 'start',
                  },
                },

                '& .MuiCardMedia-root': {
                  minWidth: '100%',
                  [theme.breakpoints.up('lg')]: {
                    ...makeArea(2, 1, 3, 4),
                  },
                },
                '& .MuiCardContent-root': {
                  '&:empty': {
                    display: 'none',
                  },

                  marginLeft: theme.spacing(5),
                  marginRight: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    marginLeft: theme.spacing(0),
                    marginRight: theme.spacing(0),
                  },
                },
                '& .MuiCardActions-root': {
                  display: 'block',

                  marginLeft: theme.spacing(8),
                  marginRight: theme.spacing(8),
                  marginTop: theme.spacing(5),
                  marginBottom: theme.spacing(5),
                  '&:focus': {
                    backgroundColor: '#FF0000',
                  },
                  [theme.breakpoints.up('lg')]: {
                    margin: theme.spacing(6),
                    alignSelf: 'start',
                  },
                },
              },
            },
            {
              props: {
                variant: 'service:heroMediaSquare',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(9),
                ...verticalCenterContentRight(theme),
                '& .MuiCardActions-root': {
                  [theme.breakpoints.up('lg')]: {
                    ...makeArea(1, 4, 3, 5),
                  },
                },
              },
            },
            {
              props: {
                variant: 'service:cardHalf',
              },
              style: {
                display: 'grid',
                [theme.breakpoints.up('lg')]: {
                  '&.MuiCard-root': {
                    gridRowGap: theme.spacing(6),
                  },
                },
                '& .MuiCardMedia-root': {
                  minWidth: '100%',
                },
                '& .MuiCardHeader-root': {
                  marginTop: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    marginTop: theme.spacing(8),
                  },
                },
                '& .MuiCardContent-root': {
                  '&:empty': {
                    display: 'none',
                  },
                },
                '& .MuiCardActions-root': {
                  display: 'block',
                },
              },
            },
            {
              props: {
                variant: 'service:campaign',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(5),
                gridTemplateColumns: '1fr',
                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '1fr 2fr',
                  gridColumnGap: theme.spacing(9),

                  '&.MuiPaper-root': {
                    gridRowGap: theme.spacing(10),
                  },
                },

                '& .MuiCardHeader-headline': {
                  alignItems: 'flex-start',
                },

                '& .MuiCardMedia-root': {
                  ...makeArea(1, 2, 2, 3),
                  marginTop: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    ...makeArea(2, 1, 3, 3),
                    marginTop: 0,
                  },
                },

                '& .MuiCardContent-root': {
                  '&:empty': {
                    display: 'none',
                  },
                  marginTop: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    marginTop: 'auto',
                  },
                },

                '& .MuiCardActions-root': {
                  display: 'block',
                  [theme.breakpoints.up('lg')]: {
                    gridColumnStart: 1,
                    gridColumnEnd: 3,

                    borderTopWidth: '1px',
                    borderTopStyle: 'solid',
                    borderTopColor: theme.palette.divider,
                  },
                },
              },
            },
            {
              props: {
                variant: 'service:list',
              },
              style: {
                display: 'grid',
                gridColumnGap: theme.spacing(9),
                [theme.breakpoints.up('lg')]: {
                  gridTemplateColumns: '1fr 1fr',
                  gridTemplateRows: 'min-content min-content 1fr',
                },

                '& .MuiCardMedia-root': {
                  minWidth: '100%',

                  [theme.breakpoints.up('lg')]: {
                    ...makeArea(2, 1, 3, 4),
                  },
                },
                '& .MuiCardHeader-root': {
                  marginTop: theme.spacing(5),
                  [theme.breakpoints.up('lg')]: {
                    marginTop: 0,
                  },
                },
                '& .MuiCardContent-root': {
                  '&:empty': {
                    display: 'none',
                  },

                  [theme.breakpoints.up('lg')]: {
                    '&:empty': {
                      display: 'block',
                    },
                  },
                },
                '& .MuiCardActions-root': {
                  display: 'block',
                  marginTop: 'auto',
                },
              },
            },
          ],
        },
      },
      defaultProps: {
        square: true,
        elevation: 0,
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: 0,
          marginTop: 'auto',
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
  },
});
